import React from 'react';
import ReviewCard from './components/ReviewCard';
import './App.css';

function App() {
  const reviews = [
    {
      title: "🔥 Find exactly what you're looking for!",
      rating: 5,
      text: "No pressure, no judgments—just a great place to connect with like-minded people. Love the privacy settings!"
    },
    {
      title: "💬 A unique and exciting experience!",
      rating: 5,
      text: "This platform is different from anything I've used before. Super secure and exciting to explore!"
    },
    {
      title: "Discreet and engaging!",
      rating: 5,
      text: "I appreciate how easy it is to start conversations without revealing too much. Feels safe and fun!"
    },
    {
      title: "🔒 Privacy at its best!",
      rating: 5,
      text: "The security features are top-notch. Private albums, hidden profiles, and no leaks—exactly what I was looking for!"
    },
    {
      title: "Great way to meet new people!",
      rating: 4,
      text: "A refreshing change from the usual apps. It’s fun, easy, and lets you connect in a natural way."
    },
    {
      title: "🔥 Exciting and interactive!",
      rating: 5,
      text: "Loving the voice feature and the way interests are matched. Makes interactions smooth and interesting!"
    }
];

  const handleDownload = () => {
    window.fbq('track', 'Click Download');
    // window.twq('track', 'Click Download');
    window.twq('event', 'tw-p4m3d-p4m6q', {});
    // window.location.href = 'https://onelink.to/desireland';
    window.location.href = 'https://desirelandapp.onelink.me/zx4q/aoj9480t';
  };

  return (
    <div className="container">
      <img src="/title_ps.webp" alt="App Header" className="header-image" />
      <button className="cta-button" onClick={handleDownload}>Download Now</button>
      <img src="/screenshots_ps.webp" alt="App Info" className="info-image" />
      
      {reviews.map((review, index) => (
        <ReviewCard
          key={index}
          title={review.title}
          rating={review.rating}
          text={review.text}
        />
      ))}
    </div>
  );
}

export default App;
